import gsap from 'gsap'

const handleShowForm = () => {
    gsap.to('.wishlist-overview', {x:"-100%"})
    gsap.to('.form-wrapper', {x:"0%"})
}

export default handleShowForm

